import { AppDispatch } from 'app/store'
import { newJobThunk, updateJobThunk } from 'features/jobs/slice'
import { getJobLocation } from 'components/GoogleMaps/utils'
import { GoogleMapLocation } from 'components/GoogleMaps/types'
import { createOrGetNetworkHomeThunk } from 'features/networkAi/slice'

export interface FetchProfilesListThunkProps {
  domainId: string | undefined
  jobName: string
  jobId: string
  homeId: string
  oldJobLocation: any
  newJobLocation: GoogleMapLocation | undefined
  isLocationChanged: boolean
  organizationId: string
  timezone: string
}

export const addNetworkThunk = ({
  domainId,
  jobId,
  jobName,
  homeId,
  oldJobLocation,
  newJobLocation,
  isLocationChanged,
  organizationId,
  timezone,
}: FetchProfilesListThunkProps) => {
  return async (dispatch: AppDispatch) => {
    //jobId is a default value but it will be updated if we have domainId
    let newJobId = jobId
    //job.location is a default value but it will be updated if isLocationChanged=true
    let location = oldJobLocation
    // if we have domainId then a new job must be created
    if (domainId) {
      newJobId = await dispatch(newJobThunk({ jobName, domainId }))
    }

    if (isLocationChanged && newJobLocation) {
      location = getJobLocation(newJobLocation)
      await dispatch(
        updateJobThunk({
          domainId: newJobId,
          payload: { location: location },
        })
      )
    }

    const body = {
      name: jobName,
      address: location?.address1, //TODO: check how to create proper address
      timezone: timezone,
      country_code: location?.country,
      latlng: {
        lat: location?.latitude,
        lng: location?.longitude,
      },
      rftemplate_id: 'bb8a9017-1e36-5d6c-6f2b-551abe8a76a2',
      homeId,
      forceCreate: true,
    }

    const mistSiteData = await dispatch(
      createOrGetNetworkHomeThunk(organizationId, body)
    )

    // Example of response: {
    //     "timezone": "UTC",
    //     "country_code": "US",
    //     "address": "37 Church St    ",
    //     "latlng": {
    //         "lat": 41.713086,
    //         "lng": -72.654453
    //     },
    //     "id": "84a35c18-4c74-4c13-9ce3-b2e75089a07c",
    //     "name": "Gondul UNLICENSED",
    //     "org_id": "3522cf07-d5d2-431c-ae4a-8bd89341a0a8",
    //     "created_time": 1666353766,
    //     "modified_time": 1666353766,
    //     "rftemplate_id": "bb8a9017-1e36-5d6c-6f2b-551abe8a76a2",
    //     "aptemplate_id": null,
    //     "secpolicy_id": null,
    //     "alarmtemplate_id": null,
    //     "networktemplate_id": null,
    //     "gatewaytemplate_id": null,
    //     "sitetemplate_id": null,
    //     "tzoffset": 0
    // }
    // const content = await rawResponse.json()
    console.log(mistSiteData)

    return newJobId
  }
}
